export default {
  fileUpload: {
    ATTACHMENTS: `Fichiers`,
    ATTACHMENTS_COUNT: `{{ count }} fichier`,
    ATTACHMENTS_COUNT_other: `{{ count }} fichiers`,
    DRAG_AND_DROP_FILE: `Déposez un fichier ou cliquez ici pour en choisir un`,
    INCORRECT_FILE_TYPE: `Type de fichier non valide`,
    LOADING_FILE: `Chargement des fichiers`,
    OPEN_FILE: `Ouvrir le fichier`,
    TOO_LARGE: `Le fichier est trop grand. Essayez un fichier inférieur à 25 Mo`
  },
  REMOVE: `Supprimer`
}
